import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate, useSearchParams } from 'react-router-dom';

import { useTransactionId } from '@/hooks/editor';
import routes from '@/routes';
import { REDIRECT_SCOPES } from '@/store/profile';

const errors = {
	generic: 'errors.generic',
	user_not_found: 'errors.userNotFound'
};

export function useOauthErrorMessage() {
	const [message, setMessage] = useState('');
	const { t } = useTranslation();

	useEffect(() => {
		async function handleOauthError(event) {
			if (
				!event.origin === window.location.origin ||
				event.data?.name !== 'oauthError'
			) {
				return;
			}

			const { error } = event.data;
			setMessage(t(errors[error] || 'errors.generic'));
		}

		window.addEventListener('message', handleOauthError);

		return () => {
			window.removeEventListener('message', handleOauthError);
		};
	}, []);

	return {
		oauthError: message,
		clearOauthError: () => setMessage('')
	};
}

export const AUTH_TRIGGER_QUERY = 'authTrigger';

export function useOauthRedirect() {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const id = useTransactionId();

	useEffect(() => {
		const authTrigger = searchParams.get(AUTH_TRIGGER_QUERY);

		if (authTrigger) {
			const [scope, type] = authTrigger.split('-');

			const redirectUrl = REDIRECT_SCOPES?.[scope]?.[type];

			setSearchParams({});

			if (redirectUrl?.startsWith('http')) {
				window.location.href = redirectUrl;

				return;
			}

			if (redirectUrl === routes.fastCheckout) {
				setTimeout(() => {
					navigate(generatePath(routes.fastCheckout, { id }), {
						state: { scope }
					});
				}, 200);

				return;
			}

			if (redirectUrl) {
				navigate(redirectUrl);
			}
		}
	}, []);
}
